import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import withModal from '../../../../../../components/global/modal/withModal';
import AlbumPurchasedCustomPrintDetailsContainer from './AlbumPurchasedCustomPrintDetailsContainer';

const propTypes = {
  actionProps: PropTypes.shape({
    purchasedCustomPrintId: PropTypes.string.isRequired,
  }),
  onRequestClose: PropTypes.func.isRequired,
};

const AlbumPurchasedCustomPrintDetailsModal = ({
  actionProps: { purchasedCustomPrintId } = {},
  ...props
}) => {
  if (!purchasedCustomPrintId) {
    return null;
  }

  return (
    <Fragment>
      <AlbumPurchasedCustomPrintDetailsContainer
        purchasedCustomPrintId={purchasedCustomPrintId}
        {...props}
      />
    </Fragment>
  );
};

AlbumPurchasedCustomPrintDetailsModal.propTypes = propTypes;

export const ALBUM_PURCHASED_CUSTOM_PRINT_DETAILS_MODAL =
  'modal/ALBUM_PURCHASED_CUSTOM_PRINT_DETAILS';

export default withModal(AlbumPurchasedCustomPrintDetailsModal, {
  name: ALBUM_PURCHASED_CUSTOM_PRINT_DETAILS_MODAL,
  size: 'xl',
});
